import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import type { VolunteerOrgActivity } from "./entity";

export const VolunteerOrgActivityEntityConfig: HyperEntityConfig<VolunteerOrgActivity> =
  {
    allowApiRead: true,
    allowApiCrud: Roles.AdminsAndManager,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;
      filter(Roles.AdminsAndManager, true);
      filter(Roles.User, false);
    },
    allowInsertPerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    allowDeleteAndUpdatePerRole(allow) {
      allow(Roles.AdminsAndManager, true);
    },
    saving(entity) {
      if (!entity.volunteerOrganizationId?.trim()) {
        throw new Error("ארגון חובה");
      }
      if (!entity.domainId?.trim()) {
        throw new Error("תחום חובה");
      }
    },
  };
